import { LazyLoad, LazyProp } from '@petconsole/pure-fe-mui';

const MailFolders = LazyLoad(() => import('./MailFolders'));
const MailMessage = LazyLoad(() => import('./MailMessage'));
const MailMessages = LazyLoad(() => import('./MailMessages'));
const MailNewMessage = LazyLoad((() => import('./MailNewMessageApp')) as LazyProp);

export { MailFolders, MailMessage, MailMessages, MailNewMessage };
